import {
  COUNTRY_CODES,
  DOCUMENT_TYPES,
  INPUT_ERROR,
  DOCUMENT_FIELDS
} from "@/constants";
import { PROOF_OF_ADDRESS_FIELDS } from "../constants/proofOfAddress";
import { getDateBeforeTomorrow } from "./date";

const {
  FIRST_NAME,
  LAST_NAME,
  GENDER,
  DATE_OF_BIRTH,
  PLACE_OF_BIRTH,
  COUNTRY,
  STATE,
  ADDRESS,
  NATIONALITY,
  PERSONAL_CODE,
  DOC_TYPE,
  DOCUMENT_SUB_TYPE,
  CATEGORY,
  DOC_NUMBER,
  DATE_OF_ISSUE,
  DATE_OF_EXPIRATION
} = DOCUMENT_FIELDS;

export function getFieldError({
  required,
  min,
  max,
  minlength,
  maxlength,
  pattern,
  value
}) {
  if (required && !value) return INPUT_ERROR.REQUIRED;
  if (value) {
    if (min && value < min) return INPUT_ERROR.MIN;
    if (max && value > max) return INPUT_ERROR.MAX;
    if (minlength && value.length < minlength) return INPUT_ERROR.MIN_LENGTH;
    if (maxlength && value.length > maxlength) return INPUT_ERROR.MAX_LENGTH;
    if (pattern && !new RegExp(pattern).test(value)) return INPUT_ERROR.PATTERN;
  }
}

const datePattern = "\\d{4}-[01]\\d-[0123]\\d";

export function getDocumentValidation(document) {
  return {
    [FIRST_NAME]: {
      required: true,
      minlength: 1,
      maxlength: 60
    },
    [LAST_NAME]: {
      required: true,
      minlength: 1,
      maxlength: 60
    },
    [GENDER]: {},
    [DATE_OF_BIRTH]: {
      required: true,
      pattern: datePattern,
      max: getDateBeforeTomorrow(document?.[DATE_OF_ISSUE])
    },
    [PLACE_OF_BIRTH]: {
      required: false,
      minlength: 1,
      maxlength: 60
    },
    [COUNTRY]: {
      required: true
    },
    [STATE]: {
      required: (function () {
        const { USA, CAN, MEX } = COUNTRY_CODES;
        const { ID_CARD, DRIVER_LICENSE } = DOCUMENT_TYPES;
        const country = document?.[COUNTRY];
        const docType = document?.[DOC_TYPE];
        // Should be required for USA driverLicense and id's
        if (country === USA) return [DRIVER_LICENSE, ID_CARD].includes(docType);
        // Should be required for CAN driverLicense and id's
        if (country === CAN) return [DRIVER_LICENSE, ID_CARD].includes(docType);
        // Should be required for MEX driverLicense
        if (country === MEX) return DRIVER_LICENSE === docType;
        return false;
      })()
    },
    [ADDRESS]: {},
    [NATIONALITY]: {
      required: (function () {
        const { USA } = COUNTRY_CODES;
        const { DRIVER_LICENSE } = DOCUMENT_TYPES;
        const country = document?.[COUNTRY];
        const docType = document?.[DOC_TYPE];
        // Should NOT be required for USA
        // Should NOT be required for drivers license
        return USA !== country && DRIVER_LICENSE !== docType;
      })()
    },
    [PERSONAL_CODE]: {
      minlength: 2,
      maxlength: 20,
      required: (function () {
        const { BGR } = COUNTRY_CODES;
        const country = document?.[COUNTRY];

        return BGR === country;
      })()
    },
    [DOC_TYPE]: {
      required: true
    },
    [DOCUMENT_SUB_TYPE]: {},
    [CATEGORY]: {
      minlength: 1,
      maxlength: 50
    },
    [DOC_NUMBER]: {
      minlength: 3,
      maxlength: 20,
      required: true
    },
    [DATE_OF_ISSUE]: {
      pattern: datePattern,
      max: getDateBeforeTomorrow(document?.[DATE_OF_EXPIRATION]),
      min: document?.[DATE_OF_BIRTH]
    },
    [DATE_OF_EXPIRATION]: {
      pattern: datePattern,
      min: document?.[DATE_OF_ISSUE] || document?.[DATE_OF_BIRTH]
    }
  };
}

export function getPOAValidation() {
  return {
    [PROOF_OF_ADDRESS_FIELDS.FIRST_NAME]: {
      required: true,
      minlength: 2,
      maxlength: 50
    },
    [PROOF_OF_ADDRESS_FIELDS.LAST_NAME]: {
      required: true,
      minlength: 2,
      maxlength: 50
    },
    [PROOF_OF_ADDRESS_FIELDS.COUNTRY]: {
      required: false
    },
    [PROOF_OF_ADDRESS_FIELDS.STREET]: {
      required: true
    },
    [PROOF_OF_ADDRESS_FIELDS.CITY]: {
      required: true
    },
    [PROOF_OF_ADDRESS_FIELDS.PARISH]: {
      required: true
    },
    [PROOF_OF_ADDRESS_FIELDS.POSTAL_CODE]: {
      required: false
    },
    [PROOF_OF_ADDRESS_FIELDS.STATE]: {
      required: false
    },
    [PROOF_OF_ADDRESS_FIELDS.ISSUE_DATE]: {
      required: false
    }
  };
}
